import React, { useContext, useEffect, useState } from 'react'
import { useTheme } from '@emotion/react'
import classNames from 'classnames'
import AppContext from 'context/app'
import Link from 'components/link'
import Container from 'components/container'
import Logo from 'components/logo'
import Menu from 'components/menu'
import Legal from 'components/legal'

export default function Nav({ style, className }){
    const theme = useTheme()
    const { clientWidth } = useContext(AppContext)
    
    const [open, setOpen] = useState(false)
    const [top, setTop] = useState(0)
    const [right, setRight] = useState('-100vw')
    const [height, setHeight] = useState('auto')

    // Close menu on navigate
    useEffect(() => {
        if(typeof window === 'undefined') return
        const handleNavigate = () => setOpen(false)
        window.addEventListener('navigate', handleNavigate)
        return () => window.removeEventListener('navigate', handleNavigate)
    }, [])
    
    // Menu slide
    useEffect(() => {
        if(typeof document === 'undefined') return
        
        const nav = document.querySelector('nav')
        if(!nav) return

        setTop(nav.clientHeight)
        setRight(open ? 0 : '-100vw')
        setHeight(`calc(100vh - ${nav.clientHeight}px)`)
    }, [open, clientWidth])
    
    return(
        <nav
            style={style}
            className={classNames(
                'p-sticky',
                'top-0',
                'bg-black',
                className
            )}
        >
            <Container
                className='d-flex j-between a-center'
                css={{
                    paddingBlock: 16,
                    paddingInline: 32,

                    [theme.queries.lg]: {
                        paddingBlock: 20,
                        paddingInline: 24,
                    },

                    [theme.queries.sm]: {
                        paddingBlock: 16,
                        paddingInline: 16,
                    },
                }}
            >
                <Logo />

                <button
                    className='d-none-lg'
                    onClick={() => setOpen(!open)}
                >
                    {open ? <img src='/svgs/x-close-white.svg' /> :
                        <img src='/svgs/hamburger-icon-white.svg' />}
                </button>

                <div
                    className='d-flex col j-between'
                    css={{
                        [theme.queries.lg]: {
                            transition: 'right .5s ease',
                            background: '#CECECE',
                            position: 'fixed',
                            width: '100%',
                            height,
                            top,
                            right,
                            zIndex: 1,
                        },
                    }}
                >
                    <Menu />
                    <Legal
                        className='d-none-lg'
                        css={{
                            '& a': { color: 'black' },
                            paddingBlock: 40,
                            paddingInline: 32,
                            [theme.queries.sm]: {
                                paddingBlock: 32,
                                paddingInline: 16,
                            },
                        }}
                    />
                </div>
            </Container>
        </nav>
    )
}
